module.exports = __webpack_public_path__ + "static/media/logo-niba-color.d8620a3e.png";